import { render, staticRenderFns } from "./referrer-receive-records.vue?vue&type=template&id=6b6fa97d&scoped=true"
import script from "./referrer-receive-records.vue?vue&type=script&lang=js"
export * from "./referrer-receive-records.vue?vue&type=script&lang=js"
import style0 from "./referrer-receive-records.vue?vue&type=style&index=0&id=6b6fa97d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6fa97d",
  null
  
)

export default component.exports